import React, { Component, Fragment } from "react";
import {
  Card,
  Tag,
  Radio,
  Icon,
  Slider,
  Checkbox,
  Row,
  Col,
  Input,
  Select,
  Tooltip,
  Collapse
} from "antd";
import F from "../../../Functions";
import WizardFooter from "./wizard-footer";
import Employed from "./images/bfile-employed.svg";
import Homemaker from "./images/bfile-housemaker.svg";
import Disabled from "./images/bfile-disabled.svg";
import Retired from "./images/bfile-retirement.svg";
import Unemployed from "./images/bfile-user.svg";
import Icon401K from "./images/new/401.svg";
import Icon403b from "./images/new/403b.svg";
import Icon457 from "./images/new/457.svg";
import IconPensionFund from "./images/new/pensionfund.svg";
import { Translate } from "react-translated";
import WizardPager from "../../../components/wizard-pager";
import SliderLayout from "./sliderlayout";

const RadioGroup = Radio.Group;
const Option = Select.Option;
const Panel = Collapse.Panel;

class Step extends Component {
  updateEmploymentStatus = (val) => {
    const { updateField, updateRadioBtnToggle } = this.props;
    // if (toggle === 'person') {
    if (val === "Employed") {
      updateField("employed_toggle", "1");
      updateField("employed_retired_disabled", null);
    } else {
      updateField("employed_toggle", "0");
      updateField("employed_retired_disabled", val);
    }
    if (!this.props.isExternalBFile) {
      updateRadioBtnToggle();
    }
  };
  updateEmploymentStatusSpouse = (val) => {
    const { updateField, updateRadioBtnToggle } = this.props;
    if (val === "Employed") {
      updateField("employed_toggle_spouse", "1");
      updateField("employed_retired_disabled_spouse", null);
    } else {
      updateField("employed_toggle_spouse", "0");
      updateField("employed_retired_disabled_spouse", val);
    }
    if (!this.props.isExternalBFile) {
      updateRadioBtnToggle();
    }
  };

  onRetirementToggleHandler = (value) => {
    if (this.props.wizard.spouse_first_name)
      this.props.updateField("asset_401k_accounts_toggle_spouse", value);
    this.props.updateField("asset_401k_accounts_toggle", value);
  };

  updateField = (name, value) => {
    this.props.updateField(name, value)
    let temp = value && value.trim() ? false : true;
    this.props.updateField('error', { ...this.props.wizard.error, [name]: temp });
    if (!this.props.isExternalBFile) {
      this.props.updateRadioBtnToggle();
    }
  }


  handleBlur = (name, value) => {
    if (!this.props.isExternalBFile) {
      this.props.handleBlur(name, value);
    }
  }


  render() {
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;

    let rangeValues = [
      "",
      "$1-$10,000",
      "$10,001-$25,000",
      "$25,001-$50,000",
      "$50,001-$100,000",
      "$100,001-$150,000",
      "$150,001-$200,000",
      "$200,001-$250,000",
      "$250,001-$300,000",
      "$300,001-$350,000",
      "$350,001-$400,000",
      "$400,001-$450,000",
      "$450,001-$500,000",
      "$500,001-$600,000",
      "$600,001-$700,000",
      "$700,001-$800,000",
      "$800,001-$900,000",
      "$900,001-$1,000,000"
    ];
    let v1, v2;
    for (let i = 1; i < 21; i++) {
      v2 = 1000000 + 100000 * i;
      v1 = v2 - 100000 + 1;
      rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    }
    rangeValues.push("$3,000,001-$4,000,000");
    rangeValues.push("$4,000,001-$5,000,000");

    // let step = 500000;
    //   for (let i = 1; i <= 18; i++) {
    //     v2 = 1000000 + step * i;
    //     v1 = v2 - step + 1;
    //     rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    //   }
      

    let marks = {};
    for (let i = 0, rangeLen = rangeValues.length; i < rangeLen; i++) {
      marks[parseInt((i / (rangeLen - 1)) * 100, 10)] = {
        label:
          i === rangeValues.length - 1 ? rangeValues[i] : i === 0 ? "$0" : "",
        val: rangeValues[i]
      };
    }

    let asset_preservation_value = 0;
    if (wizard.asset_preservation_value !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.asset_preservation_value) {
          asset_preservation_value = parseInt(x, 10);
        }
      }
    }

    let asset_preservation_value_spouse = 0;
    if (wizard.asset_preservation_value_spouse !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.asset_preservation_value_spouse) {
          asset_preservation_value_spouse = parseInt(x, 10);
        }
      }
    }

    let asset_401k_accounts = [];
    if (wizard.asset_401k_accounts !== null &&
      wizard.asset_401k_accounts !== "") {
      asset_401k_accounts = JSON.parse(wizard.asset_401k_accounts);
    }
    let asset_401k_accounts_spouse = [];
    if (wizard.asset_401k_accounts_spouse !== null &&
      wizard.asset_401k_accounts_spouse !== "") {
      asset_401k_accounts_spouse = JSON.parse(
        wizard.asset_401k_accounts_spouse
      );
    }

    let employment_status = "";
    if (wizard.employed_toggle === "1") {
      employment_status = "Employed";
    }
    if (wizard.employed_toggle === "0") {
      employment_status = "Unemployed";

      if (wizard.employed_retired_disabled === "Disabled") {
        employment_status = "Disabled";
      }
      if (wizard.employed_retired_disabled === "Stay-at-Home") {
        employment_status = "Stay-at-Home";
      }
      if (wizard.employed_retired_disabled === "Retired") {
        employment_status = "Retired";
      }
      if (wizard.employed_retired_disabled === "Unemployed") {
        employment_status = "Unemployed";
      }
    }

    let employment_status_spouse = "";
    if (wizard.employed_toggle_spouse === "1") {
      employment_status_spouse = "Employed";
    }
    if (wizard.employed_toggle_spouse === "0") {
      employment_status_spouse = "Unemployed";

      if (wizard.employed_retired_disabled_spouse === "Disabled") {
        employment_status_spouse = "Disabled";
      }
      if (wizard.employed_retired_disabled_spouse === "Stay-at-Home") {
        employment_status_spouse = "Stay-at-Home";
      }
      if (wizard.employed_retired_disabled_spouse === "Retired") {
        employment_status_spouse = "Retired";
      }
      if (wizard.employed_retired_disabled_spouse === "Unemployed") {
        employment_status_spouse = "Unemployed";
      }
    }

    const employment_status_items = [
      { name: "Employed", icon: Employed },
      { name: "Unemployed", icon: Unemployed },
      { name: "Retired", icon: Retired },
      { name: "Stay-at-Home", icon: Homemaker },
      { name: "Disabled", icon: Disabled }
    ];

    const asset_401k_accounts_items = [
      {
        name: "401 (k)",
        icon: Icon401K,
        tip:
          "An employer sponsored retirement plan offered to employees to help save for retirement.  Money is usually payroll deducted.  The employee chooses the mutual funds within the plan to try and grow the funds for retirement."
      },
      {
        name: "403 (b)",
        icon: Icon403b,
        tip:
          "A retirement plan offered to employees or teachers in the public schools."
      },
      {
        name: "457",
        icon: Icon457,
        tip:
          "A retirement plan offered to government employees (e.g. police or firefighters)."
      },
      {
        name: "Pension Fund",
        icon: IconPensionFund,
        tip: "Pension Fund"
      }
      /*{
                name: 'None',
                icon: IconNo,
                tip: ""
            }*/
    ];

    const selectyears_options = [
      {
        name: "Under 1 Year",
        value: "Under 1 Year"
      },
      {
        name: "1 to 5 years",
        value: "1 to 5"
      },
      {
        name: "5 to 10 years",
        value: "5 to 10"
      },
      {
        name: "10+ years",
        value: "10 +"
      }
    ];

    F.log("wizard ==>> Step-(4-1) ==>> ", wizard);

    // Direct container reference to override App.js configuration
    const getCustomContainer = () => document.body;


    return (
      <Fragment>
        <div className="stepBody">
          <Card
            className="insidecard stepcard" >
            <h5 className="headingText">“What is your current employment status?”</h5>
            <Radio.Group
              className="radiogroup"
              value={employment_status}
              onChange={(e) => this.updateEmploymentStatus(e.target.value)}

            >

              {employment_status_items.map((item, i) => {
                return (

                  <Radio value={item.name}>
                    <label className='label'>
                      {item.name}
                    </label>
                  </Radio>

                );
              })}

            </Radio.Group>
            <Row gutter={8} style={{ marginTop: 20 }}>
              {F.log(wizard.employed_toggle, "wizard.employed_toggle")}
              {wizard.employed_toggle && wizard.employed_toggle === "1" ? (
                <Col xs={24} sm={24} md={24} lg={24} xl={6} style={{ marginBottom: "16px" }}>
                  <label className='label textContent'>
                    Employer Name <span className='asteriskIcon'>*</span>
                  </label>
                  <Input className={wizard && wizard.error && wizard.error['employer_name'] && 'error'}
                    value={wizard.employer_name}
                    onChange={(e) => this.updateField("employer_name", e.target.value)}
                    onBlur={(e) => this.handleBlur("employer_name", e.target.value)}
                  />
                </Col>
              ) : null}

              {wizard.employed_toggle === "1" ? (
                <Col xs={24} sm={24} md={24} lg={24} xl={6} style={{ marginBottom: "16px" }}>
                  <label className='label textContent'>
                    Experience <span className='asteriskIcon'>*</span>
                  </label>
                  {/* <Input
                value={wizard.employer_years}
                onChange={(e) => updateField("employer_name", e.target.value)}
              /> */}
                  <Select className={wizard && wizard.error && wizard.error['employer_years'] && 'error'}
                    value={wizard.employer_years}
                    style={{ width: "100%" }}
                    onChange={(value) => {
                      this.updateField("employer_years", value);
                    }
                    }
                  >
                    <Option value={""} className="textContent">
                      Select
                    </Option>
                    {selectyears_options.map((item, i) => (
                      <Option value={item.value} key={i} className="textContent">
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Col>
              ) : null}

              {wizard.employed_toggle === "0" &&
                wizard.employed_retired_disabled === "Retired" ? (
                <Col xs={24} sm={24} md={24} lg={24} xl={6} style={{ marginBottom: "16px" }}>
                  <label className='label textContent'>
                    Retire Company Name <span className='asteriskIcon'>*</span>
                  </label>
                  <Input className={wizard && wizard.error && wizard.error['employer_retire_from'] && 'error'}
                    value={wizard.employer_retire_from}
                    onChange={(e) => {
                      this.updateField("employer_retire_from", e.target.value);
                    }
                    }

                  />
                </Col>
              ) : null}
            </Row>

            {wizard.spouse_first_name && (
              <Collapse defaultActiveKey={["1"]} style={{ marginTop: 20 }}>
                <Panel header={<Translate text={"Click to add spouse/partner info"} />}>
                  <div>
                    <h4 className="titleTextUnderline">
                      <Translate text={`Spouse/Partner Employment Status`} />
                    </h4>
                    <div>
                      <h5 className="headingText">
                        "What's your current employment status?"
                      </h5>

                      <Radio.Group
                        className="radiogroup"
                        value={employment_status_spouse}
                        style={{ width: "100%" }}
                        onChange={(e) =>
                          this.updateEmploymentStatusSpouse(e.target.value)
                        }
                      >

                        {employment_status_items.map((item, i) => {
                          return (

                            <Radio value={item.name}>

                              <label className="label">
                                <Translate text={item.name} />
                              </label>

                            </Radio>

                          );
                        })}

                      </Radio.Group>
                    </div>

                    <Row gutter={8} style={{ marginTop: 20 }}>
                      {wizard.employed_toggle_spouse === "1" ? (
                        <Col className="" span={6}>
                          <label className="label">
                            <Translate text={`Employer Name`} />:
                          </label>
                          <Input
                            value={wizard.employer_name_spouse}
                            onChange={(e) =>
                              updateField("employer_name_spouse", e.target.value)
                            }
                            onBlur={(e) => {
                              if (!this.props.isExternalBFile) {
                                handleBlur("employer_name_spouse", e.target.value);
                              }
                            }
                            }
                          />
                        </Col>
                      ) : null}
                      {wizard.employed_toggle_spouse === "1" ? (
                        <Col className="" span={6}>
                          {/* <label className="label">
                        <Translate text={`Experience`} />:
                      </label>
                      <Input
                        value={wizard.employer_years_spouse}
                        onChange={(e) =>
                          updateField("employer_years_spouse", e.target.value)
                        }
                      /> */}
                          <label className='label textContent'>Experience</label>
                          <Select
                            value={wizard.employer_years_spouse}
                            style={{ width: '100%' }}
                            onChange={(value) =>
                              updateField("employer_years_spouse", value)
                            }
                            onBlur={(value) => {
                              if (!this.props.isExternalBFile) {
                                handleBlur("employer_years_spouse", value);
                              }
                            }
                            }
                          >
                            <Option value={""}>
                              <Translate text={`Select`} />
                              ...
                            </Option>
                            {selectyears_options.map((item, i) => (
                              <Option value={item.value} key={i}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        </Col>
                      ) : null}
                      {wizard.employed_toggle_spouse === "0" &&
                        wizard.employed_retired_disabled_spouse === "Retired" ? (
                        <Col className="" span={6}   >
                          <label className='label textContent'>
                            Retire Company Name
                          </label>
                          <Input
                            value={wizard.employer_retire_from_spouse}
                            onChange={(e) =>
                              updateField(
                                "employer_retire_from_spouse",
                                e.target.value
                              )
                            }
                            onBlur={(e) => {
                              if (!this.props.isExternalBFile) {
                                handleBlur(
                                  "employer_retire_from_spouse",
                                  e.target.value
                                );
                              }
                            }
                            }
                            style={{ width: 250 }}
                          />
                        </Col>
                      ) : null}
                    </Row>
                  </div>
                </Panel>
              </Collapse>

            )}


            <div style={{ marginTop: 20 }}>
              <h4 className="titleTextUnderline textContent">Retirement Plan</h4>
              <div>
                <h5 className="headingText"> “Do you, or your spouse/partner, have a retirement plan ?” <span className='asteriskIcon'>*</span></h5>
                <RadioGroup className="radiogroup"
                  value={wizard.asset_401k_accounts_toggle}
                  onChange={(e) => this.onRetirementToggleHandler(e.target.value)}
                >
                  <Radio value={1}>
                    <Translate text={`Yes`} />
                  </Radio>
                  <Radio value={0}>
                    <Translate text={`No`} />
                  </Radio>
                </RadioGroup>

              </div>


              {wizard.asset_401k_accounts_toggle ? (
                <div style={{ marginTop: 20 }}>
                  <h5 className="titleText2 headingText">Please Select Checklist : <span className='asteriskIcon'>*</span></h5>
                  <Checkbox.Group
                    value={asset_401k_accounts}
                    style={{ width: "100%" }}
                    onChange={(checkedList) => {
                      if (
                        checkedList.indexOf("None") >= 0 &&
                        asset_401k_accounts.indexOf("None") < 0
                      ) {
                        checkedList = ["None"];
                        updateField("asset_preservation_value", "");
                      }
                      if (
                        checkedList.indexOf("None") >= 0 &&
                        asset_401k_accounts.indexOf("None") >= 0 &&
                        checkedList.length > 1
                      ) {
                        const i = checkedList.indexOf("None");
                        checkedList.splice(i, 1);
                      }
                      if (checkedList.length === 0) {
                        updateField("asset_preservation_value", ""); // new add
                      }
                      updateField(
                        "asset_401k_accounts",
                        JSON.stringify(checkedList)
                      );
                    }}
                    onBlur={() => {
                      if (!this.props.isExternalBFile) {
                        handleBlur("asset_401k_accounts", JSON.stringify(asset_401k_accounts));

                        if (
                          asset_401k_accounts.indexOf("None") >= 0 ||
                          asset_401k_accounts.length === 0
                        ) {
                          handleBlur("asset_preservation_value", "");
                        }
                      }
                    }}
                  >
                    <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                      {asset_401k_accounts_items.map((item, i) => {
                        return (
                          <Col key={i}
                            xs={24}
                            sm={12}
                            md={8}
                            lg={6} className="checkbox_layout">
                            {item.tip !== "" ? (
                              <Tooltip placement="bottom" title={item.tip} getPopupContainer={getCustomContainer}>
                                <Checkbox value={item.name} style={{ width: "100%" }}>
                                  <div className="checkbox_items"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <div className="icon"
                                      style={{ flexShrink: 0 }}
                                    >
                                      <img src={item.icon} alt={item.name}
                                        style={{
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                    <div className="title" style={{ flexGrow: 1 }}>
                                      <Translate text={item.name} />
                                    </div>
                                  </div>
                                </Checkbox>
                              </Tooltip>
                            ) : (
                              <Checkbox value={item.name} style={{ width: "100%" }}>
                                <div className="checkbox_items">
                                  <div className="icon">
                                    <img src={item.icon} alt={item.name}
                                      style={{
                                        objectFit: "contain",
                                      }}
                                    />
                                  </div>
                                  <div className="title" style={{ flexGrow: 1 }}>
                                    <Translate text={item.name} />
                                  </div>
                                </div>
                              </Checkbox>
                            )}
                          </Col>
                        );
                      })}
                    </Row>
                  </Checkbox.Group>

                  {F.log("11", asset_401k_accounts)}
                  {asset_401k_accounts &&
                    asset_401k_accounts.length > 0 &&
                    asset_401k_accounts.indexOf("None") < 0 ? (
                    <div style={{ marginTop: 20 }}>
                      <h5 className="headingText">“What is the approximate value of the retirement plan ?” <span className='asteriskIcon'>*</span></h5>
                      <SliderLayout
                        marks={marks}
                        value={asset_preservation_value}
                        name="asset_preservation_value"
                        updateField={updateField}
                        updateRadioBtnToggle={updateRadioBtnToggle}
                      />
                      <div className="sliderValue center-align">
                        {wizard.asset_preservation_value || "$0"}
                      </div>
                    </div>
                  ) : null}

                  {wizard.spouse_first_name && (
                    <Collapse defaultActiveKey={["1"]} style={{ marginTop: 20 }}>
                      <Panel header={<Translate text={"Click to add spouse/partner info"} />}>
                        <div style={{ marginTop: "15px" }}>
                          <h4 className="titleTextUnderline">
                            <Translate text={`Add Spouse/Partner (Retirement Details)`} />
                          </h4>
                          <div>
                            <h5 className="titleText2 headingText">Please Select Checklist : </h5>
                            <Checkbox.Group
                              className=""
                              value={asset_401k_accounts_spouse}
                              style={{ width: "100%" }}
                              onChange={(checkedList) => {
                                if (
                                  checkedList.indexOf("None") >= 0 &&
                                  asset_401k_accounts_spouse.indexOf("None") < 0
                                ) {
                                  checkedList = ["None"];
                                  updateField(
                                    "asset_preservation_value_spouse",
                                    ""
                                  );
                                }
                                if (
                                  checkedList.indexOf("None") >= 0 &&
                                  asset_401k_accounts_spouse.indexOf("None") >=
                                  0 &&
                                  checkedList.length > 1
                                ) {
                                  const i = checkedList.indexOf("None");
                                  checkedList.splice(i, 1);
                                }
                                if (checkedList.length === 0) {
                                  updateField(
                                    "asset_preservation_value_spouse",
                                    ""
                                  ); // new add
                                }
                                updateField(
                                  "asset_401k_accounts_spouse",
                                  JSON.stringify(checkedList)
                                );
                              }}
                              onBlur={() => {
                                if (!this.props.isExternalBFile) {
                                  handleBlur(
                                    "asset_401k_accounts_spouse",
                                    JSON.stringify(asset_401k_accounts_spouse)
                                  );
                                  if (
                                    asset_401k_accounts_spouse.indexOf("None") >= 0 ||
                                    asset_401k_accounts_spouse.length === 0
                                  ) {
                                    handleBlur("asset_preservation_value_spouse", "");
                                  }
                                }
                              }}

                            >
                              <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap' }} >
                                {asset_401k_accounts_items.map((item, i) => {
                                  return (
                                    <Col key={i}
                                      xs={24}
                                      sm={12}
                                      md={8}
                                      lg={6} className="checkbox_layout">
                                      {item.tip !== "" ? (
                                        <Tooltip
                                          placement="bottom"
                                          title={item.tip}
                                          getPopupContainer={getCustomContainer}
                                        >
                                          <Checkbox value={item.name} style={{ width: "100%" }}>
                                            <div className="checkbox_items"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                              }}
                                            >
                                              <div className="icon">
                                                <img
                                                  src={item.icon}
                                                  alt={item.name}
                                                />
                                              </div>
                                              <div className="title">
                                                <Translate text={item.name} />
                                              </div>
                                            </div>
                                          </Checkbox>
                                        </Tooltip>
                                      ) : (
                                        <Checkbox value={item.name}>
                                          <div className="checkbox_items">
                                            <div className="icon">
                                              <img
                                                src={item.icon}
                                                alt={item.name}
                                              />
                                            </div>
                                            <div className="title">
                                              <Translate text={item.name} />
                                            </div>
                                          </div>
                                        </Checkbox>
                                      )}
                                    </Col>
                                  );
                                })}
                              </Row>
                            </Checkbox.Group>

                          </div>
                          {F.log(
                            asset_401k_accounts_spouse,
                            "asset_401k_accounts_spouse"
                          )}
                          {asset_401k_accounts_spouse &&
                            asset_401k_accounts_spouse.length > 0 &&
                            asset_401k_accounts_spouse.indexOf("None") < 0 ? (
                            <div  >
                              <h5 className="headingText">“What is the approximate value of the retirement plan ?” </h5>
                              <SliderLayout
                                marks={marks}
                                value={asset_preservation_value_spouse}
                                name="asset_preservation_value_spouse"
                                updateField={updateField}
                                updateRadioBtnToggle={updateRadioBtnToggle}
                              />
                              <div className="sliderValue center-align">
                                {wizard.asset_preservation_value_spouse || "$0"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </Panel>
                    </Collapse>
                  )}
                </div>
              ) : null}
            </div>

            <Row style={{ display: 'flex', justifyContent: 'center' }} className='center'>
              <Col span={18} className='didyouKnowSection'>
                {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                <h4>Did You Know</h4>
                <p className="textContent">“The 401K is often times the first place people go to get money when they suffer a financial hardship. Often times this financial hardship involves a liability award where the insured did not have adequate liability limits on his or her policy”</p>
              </Col>
            </Row>
            {/* <WizardFooter {...this.props} /> */}
          </Card>
        </div>
        <div className='stepFooter'>
          <WizardFooter {...this.props} />
        </div>
      </Fragment>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step4_1_updated.js